import { Component, OnInit } from '@angular/core';
import { ImportsModule } from '../../imports';
import { MessageService, TreeNode } from 'primeng/api';
import { Column } from '../Column';
import { ChartService } from '../../services/chart.service';
import { DetailTableData } from '../../shared/types';
import { DetailTableComponent } from "../../shared/components/detail-table/detail-table.component";
import { FileService } from '../../services/file.service';

@Component({
  selector: 'app-supporting-objects',
  standalone: true,
  imports: [
    ImportsModule,
    DetailTableComponent
  ],
  templateUrl: './supporting-objects.component.html',
  styleUrl: './supporting-objects.component.css'
})
export class SupportingObjectsComponent implements OnInit {
  treeTableResults: TreeNode[] = [];
  tableColumns: Column[] = [];
  detailColumns: Column[] = [];
  showDetail = false;
  detailTableData: DetailTableData = {} as DetailTableData;
  detailTableResults: {
    [key: string]: string,
  }[] = [];
  globalFilterFields: string[] = [];
  isLoading = false;
  isBusy = false;

  constructor(
    private chartService: ChartService,
    private messageService: MessageService,
    private fileService: FileService
  ) { }
  
  ngOnInit() {
    this.tableColumns = [
      { label: 'Object Type', field: 'object_type', width: 135, expandable: true },  
      { label: 'Object Library', field: 'object_library', width: 175, expandable: true },
      { label: 'Attribute', field: 'attribute', width: 175 },
      { label: 'Total Objects', field: 'total_objects', width: 175, align: 'right' }
    ]

    this.detailColumns = [
      { label: 'Name', field: 'object_name', width: 175, filterType: 'text', matchMode: "contains"  },
      { label: 'Library', field: 'object_library', width: 175, filterType: 'text', matchMode: "contains"  },
      { label: 'Type', field: 'object_type', width: 100, filterType: 'select'},
      { label: 'Attribute', field: 'object_attribute', width: 150, filterType: 'select' },
      { label: 'Text', field: 'object_text', width: 200, filterType: 'text', matchMode: "contains"  },
      { label: "Src Match", field: "object_srcMatch", width: 175, filterType: 'text', matchMode: "contains" },
      { label: "Reason", field: "object_reason", width: 175, filterType: 'text', matchMode: "contains" },
      { label: "Notes", field: "object_notes", width: 175, matchMode: "contains", filterType: 'text',  },
      { label: "Lib Text", field: "library_text", width: 175, matchMode: "contains", filterType: 'text'  },
      { label: 'Lib Type', field: 'library_type', width: 150, filterType: 'select' },
      { label: 'Lib Category', field: 'library_category', width: 150, filterType: 'select' },
      { label: "Lib Notes", field: "library_notes", width: 175, matchMode: "contains", filterType: 'text'  },
      { label: "Created", field: "object_created", width: 175, filterType: 'date'},
      { label: "Changed", field: "object_changed", width: 175, filterType: 'date' },
      { label: "Last Used", field: "object_lastUsed", width: 175, filterType: 'date' },
      { label: "Restored", field: "object_restored", width: 175, filterType: 'date' }
    ]

    this.chartService.getSupportingObjects().subscribe({
      next:(data: any) => {
        if(data.rows.length === 0) return;
        this.treeTableResults = data.rows.map((item: any) => {
          return {
            data: {
              object_type: item.object_type,
              object_library: '',
              attribute: '',
              total_objects: item.total_objects == null ? 0 : item.total_objects
            },
            leaf: false
          }
        });
      },
      complete: () => {
        this.treeTableResults.forEach((item: TreeNode) => {
          this.chartService.getSupportingObjectsByType(item.data.object_type).subscribe({
            next: (data: any) => {
              if(data.rows.length === 0) return;
              item.children = data.rows.map((child: any) => {
                return {
                  data: {
                    object_type: item.data.object_type,
                    object_library: child.object_library,
                    attribute: '',
                    total_objects: child.total_objects == null ? 0 : child.total_objects
                  },
                  leaf: false
                }
              });
            },
            complete: () => {
              item.children?.forEach((child: TreeNode) => {
                this.chartService.getSupportingObjectsByLibrary(item.data.object_type, child.data.object_library).subscribe({
                  next: (data: any) => {
                    if(data.rows.length === 0) return;
                    child.children = data.rows.map((grandchild: any) => {
                      return {
                        data: {
                          object_type: item.data.object_type,
                          object_library: child.data.object_library,
                          attribute: grandchild.object_attribute == '' ? 'None' : grandchild.object_attribute,
                          total_objects: grandchild.total_objects == null ? 0 : grandchild.total_objects
                        },
                        leaf: true
                      }
                    });
                  }
                });
              });
            }
          });
        });
      }
    })
  }

  isNumber(value: any): boolean {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  showDetailedTable(col: any, rowData: any, rowNode: any, ) {
    if(rowNode.leaf === true && col === 'attribute'){
      this.isLoading = true;
      this.chartService.getSupportingObjectsDetail(rowData.object_type, rowData.object_library, (rowData.attribute === 'None' ? '': rowData.attribute)).subscribe({
        next: (data: any) => {
          this.detailTableResults = data.rows.map((item: any) => {
            return {
              object_name: item.object_name,
              object_library: item.object_library,
              object_type: item.object_type,
              object_attribute: item.object_attribute,
              object_text: item.object_text,
              object_srcMatch: item.object_srcMatch,
              object_reason: item.object_reason,
              object_notes: item.object_notes,
              library_text: item.library_text,
              library_type: item.library_type,
              library_category: item.library_category,
              library_notes: item.library_notes,
              object_created: item.object_created,
              object_changed: item.object_changed,
              object_lastUsed: item.object_lastUsed,
              object_restored: item.object_restored
            }
          });
          this.showDetail = true;
          this.detailTableData = {
            items: this.detailTableResults,
            columns: this.detailColumns,
            globalFilterFields: this.globalFilterFields,
            detailTableResults: this.detailTableResults
          }
        }
      });
    }
  }
  backToSummary() {
    this.showDetail = false;
    this.detailTableResults = [];
  }

  async exportExcel() {
    this.isBusy = true;
    this.messageService.add({ severity: 'info', summary: 'Processing', detail: 'The data from this table is being processed into a file', sticky: true, key:'bc' });

    const firstData = this.treeTableResults.map((item: any) => {
      return item.data;
    });
    const buffer = await this.fileService.createExcel(firstData, 'Supporting Objects Data');
    this.fileService.saveAsExcelFile(buffer, 'Supporting Objects Data');
    this.isBusy = false;
  }
}
